import Vue from "vue";
import Router from "vue-router";
import homeindex from '@/components/home/homeindex.vue'

import BUIndex from "@/components/BU/BUindex.vue";
import BU01 from "@/components/BU/01.vue";
import BU01KB from "@/components/BU/01KB.vue";
import BU01PB from "@/components/BU/01PB.vue";
//import BU01download from "@/components/BU/BU01download.vue";

import BHIndex from '@/components/BH/BHindex.vue';
import BH04 from '@/components/BH/04.vue';
import BH04KB from '@/components/BH/04KB.vue';

import RUIndex from '@/components/RU/RUindex.vue';
import RU02 from '@/components/RU/02.vue';
import RU03 from '@/components/RU/03.vue';


import RHIndex from '@/components/RH/RHindex.vue';
import RH06 from '@/components/RH/06.vue';
import RH07 from '@/components/RH/07.vue';
import RH21 from '@/components/RH/21.vue';

import SMQIndex from '@/components/SMQ/SMQindex.vue';
import SMQ02 from '@/components/SMQ/02.vue';
import SMQ02PB from '@/components/SMQ/02PB.vue';


import BU04Index from '@/components/BU04/BU04index.vue';
import  BU04PB from '@/components/BU04/PB.vue';
Vue.use(Router);
// 今后使用异步加载路由的方式开发

export const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/BU",
      component: BUIndex,
      children: [
        {
          path: "01",
          component: BU01,
          meta: {
            title: "BU01"
          }
        },
        {
          path: "01KB",
          component: BU01KB,
          meta: {
            title: "BU01KB"
          }
        },
        {
          path: "01PB",
          component: BU01PB,
          meta: {
              title: "BU01PB"
          }
        },
        {
          path: "",
          component: BU01,
          meta: {
              title: "BU01"
          }
        }
      ]
    },
    {
      path: "/BH",
      component: BHIndex,
      children: [
        {
          path: "04",
          component: BH04,
          meta: {
            title: "BH04"
          }
        },
        {
          path: "04KB",
          component: BH04KB,
          meta: {
            title: "BH04KB"
          }
        },
        {
          path: "",
          component: BH04,
          meta: {
              title: "BH04"
          }
        }
      ]
    },
    {
      path: "/RU",
      component: RUIndex,
      children: [
        {
          path: "02",
          component: RU02,
          meta: {
            title: "RU02"
          }
        },
        {
          path: "03",
          component: RU03,
          meta: {
            title: "RU03"
          }
        },
        {
            path: "",
            component: RU02,
            meta: {
                title: "RU02"
            }
        }
      ]
    },
    {
        path: "/RH",
        component: RHIndex,
        children: [
            {
              path: "06",
              component: RH06,
              meta: {
                title: "RH06"
              }
            },
            {
              path: "07",
              component: RH07,
              meta: {
                title: "RH07"
              }
            },
            {
              path: "21",
              component: RH21,
              meta: {
                title: "RH21"
              }
            },
            {
                path: "",
                component: RH06,
                meta: {
                  title: "RH06"
                }
            }
          ]
    },
    {
      path: "/SMQ",
      component: SMQIndex,
      children: [
          {
            path: "02",
            component: SMQ02,
            meta: {
              title: "BU02"
            }
          },
          {
            path: "02PB",
            component: SMQ02PB,
            meta: {
              title: "BU02PB"
            }
          },
          {
            path: "",
            component: SMQ02,
            meta: {
              title: "BU02"
            }
          }
          
          
        ]
  },
  {
    path: "/BU04",
    component: BU04Index,
    children: [
        {
          path: "PB",
          component: BU04PB,
          meta: {
            title: "BU04PB"
          }
        },
        {
          path: "",
          component: BU04PB,
          meta: {
            title: "BU04PB"
          }
        }
        
        
      ]
},
    {
      path: "/homeindex",
      component: homeindex
    },
    {
      path: "",
      component: homeindex
    }
    
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js